import { useAgentUI } from 'components/agent/agent-panel-wrapper';
import { useAuth } from 'lib/auth';
import posthog from 'posthog-js';

/** The sidebar footers' ask-AI action, shared so its consumers don't drift apart. */
export const useAskAi = (): (() => void) => {
  const auth = useAuth();
  const { togglePanel } = useAgentUI();

  return () => {
    posthog?.capture('kapa_ask_ai_button_clicked', {
      project_id: auth.project.selected?.id,
      project_name: auth.project.selected?.project_name,
    });
    togglePanel();
  };
};
